<template>
    <el-dialog class="dialog dialog-mini" :visible="dialogs.login" customClass="dialog_main dialog-mini_main" :append-to-body="true" :close-on-click-modal="false" @close="closeDialog()">
        <div slot="title" class="dialog__head dialog__head_second">
            <div class="dialog__head-inner">
                <h3 class="dialog__title">Авторизация пользователя</h3>
            </div>
        </div>

        <div slot="default" class="dialog__inner">
            <form class="search-form" @submit.prevent="submitSelected">
                <div class="dialog__content">
                    <validate-input v-model="email" placeholder="Почта" type="email" v-bind:error="emailError" v-on:update:error="emailError = $event" :validateOptions="['empty', 'email']" />

                    <validate-input class="mt-8" v-model="password" placeholder="Пароль" type="password" v-bind:error="passwordError" v-on:update:error="passwordError = $event" :validateOptions="['empty']" />
                </div>

                <footer slot="footer" class="dialog__footer mt-24">
                    <div class="dialog__footer-inner">
                        <div class="dialog__footer-item">
                            <button type="button" class="btn" @click="closeDialog">Отменить</button>
                        </div>
                        <div class="dialog__footer-item">
                            <button type="submit" class="btn btn_action" :disabled="!email.length || !password.length || emailError || passwordError">Авторизация</button>
                        </div>
                    </div>
                </footer>
            </form>
        </div>
    </el-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';

import dialog from '@/mixins/dialog';
import ValidateInput from '@/components/ValidateInput'

export default {
    mixins: [ dialog ],
    components: {
        ValidateInput
    },
    data() {
        return {
            email: '',
            emailError: false,
            emailErrorText: '',
            password: '',
            passwordError: false,
            passwordErrorText: '',
        }
    },
    methods: {
        ...mapActions('tokens', ['LOGIN']),
        ...mapActions('user', ['LOAD_USER']),
        ...mapMutations('common', ['TOGGLE_ALERT']),

        closeDialog() {
            this.email = ''
            this.emailError = false
            this.password = ''
            this.passwordError = false

            this.elDialogs.login = false;
        },
        async submitSelected() {
            const email = encodeURI(this.email)
            const password = encodeURI(this.password)

            const params = {
                email,
                password
            }

            await this.LOGIN(params).then(status => {
                if (status === 200 ) {
                    this.LOAD_USER()
                    this.closeDialog();
                    this.$router.push({ path: `/profile` }).catch(()=>{});
                } else {
                    this.TOGGLE_ALERT({open: true, text: 'Проверьте почту и пароль и попробуйте ещё раз'})
                }
            })
        }
    },
    computed: {
        ...mapState('tokens', ['accessToken'])
    }
}
</script>
